import React from 'react'
import './projects.css'
import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'

var Translate = require('react-translate-component')

const images = [
  '/offersGallery/FnrNP2x.png',
  '/offersGallery/Focus.png',
  '/offersGallery/InterContinental.png',
  '/offersGallery/WKL.png',
  '/offersGallery/II.png',
  '/offersGallery/Marszalkowska.png',
  '/offersGallery/WW.png',
  '/offersGallery/hurtownia.png'
]

const customStyles = {
  overlay: { zIndex: 1099 }
}
export default class ProjectCard extends React.Component {
  constructor () {
    super(...arguments)
    this.state = {
      photoIndex: 0,
      isGalleryOpen: false
    }
  }

  handleClick (id) {
    this.setState({
      isGalleryOpen: true,
      photoIndex: id
    })
  }
  render () {
    const { photoIndex, isGalleryOpen } = this.state
    return (
      <Card
        className='mt-5 cardShadow'
        onClick={() => this.handleClick(this.props.cardIndex)}
      >
        <div className='cardHeader'>
          <img
            className='card-img'
            src={require(`./images/${this.props.image}.png`)}
            alt=''
          />
          <div className='card-img-overlay'>
            <img
              className='card-magnifier'
              src={require(`./images/magnifier.png`)}
              alt='magnifier'
            />
            <h4 className='cardImg-title'>
              <Translate content={this.props.description} />
            </h4>
          </div>
        </div>

        <CardBody className='cardBody'>
          <CardSubtitle className='cardSubtitle'>
            <Translate content={this.props.subtitle} />
          </CardSubtitle>
          <CardTitle className='cardTitle'>
            <Translate content={this.props.title} />
          </CardTitle>
        </CardBody>

        {isGalleryOpen && (
          <Lightbox
            reactModalStyle={customStyles}
            mainSrc={process.env.PUBLIC_URL + images[photoIndex]}
            nextSrc={
              process.env.PUBLIC_URL + images[(photoIndex + 1) % images.length]
            }
            prevSrc={
              process.env.PUBLIC_URL +
              images[(photoIndex + images.length - 1) % images.length]
            }
            onCloseRequest={() => this.setState({ isGalleryOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </Card>
    )
  }
}
